// Counts whole characters (Unicode code points) rather than UTF-16 code units, so an astral-plane
// character (emoji, some CJK) counts as one instead of two. Used by the SavedLists name/note counters
// so the "X/50" reading matches what a person perceives as one character (TMS-2332, consistent with
// TMS-2330/2331). Array.from iterates by code point.
const countCharacters = (value) => (value ? Array.from(value).length : 0);

export default countCharacters;
